import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import fixedPriceImg from '../../assets/img/models/fixed_price_model.png';
import dedicatedImg from '../../assets/img/models/dedicated_model.png';
import tmImg from '../../assets/img/models/tm_model.png';

// Maskgroup icons as per user guidance
import mask1 from '../../assets/img/icons/Maskgroup1.png';
import mask2 from '../../assets/img/icons/Maskgroup2.png';
import mask3 from '../../assets/img/icons/Maskgroup3.png';
import mask4 from '../../assets/img/icons/Maskgroup4.png';

const ModelsSection = () => {
  const [currentModel, setCurrentModel] = useState(0);

  const models = [
    {
      id: "fixed-price",
      title: "Fixed Price Model",
      desc: "Scan to BIM service company strategic planning and flexible engagement models make starting your project effortless. Here's our seamless process to kick off your architectural solution.",
      benefits: [
        "Simplified",
        "Predictability",
        "Greater Transparency",
        "No additional Cost",
        "Reduced Risk",
        "Low Management effort"
      ],
      cta: "Inquire Now",
      nodes: [
        { label: "Requirement Gathering", icon: mask1.src || mask1 },
        { label: "Analysis and Planning", icon: mask2.src || mask2 },
        { label: "Design & Prototyping", icon: mask3.src || mask3 },
        { label: "Development & Integrations", icon: mask4.src || mask4 },
        { label: "Deployment", icon: mask1.src || mask1 },
        { label: "Support & Maintenance", icon: mask2.src || mask2 }
      ]
    },
    {
      id: "dedicated",
      title: "Dedicated Hiring Model",
      desc: "Dedicated hiring model is ideal for long-term projects with evolving requirements, complex development processes, or when the client wants to maintain control over the development process.",
      benefits: [
        "Access to global talent",
        "Greater flexibility",
        "Complete control",
        "Focused and dedicated approach",
        "Faster time to market"
      ],
      cta: "Get a Quote",
      steps: [
        "Requirements Gathering",
        "Share Resumes of Resources",
        "Interview & Shortlisting By Clients",
        "Project Assigning & Onboarding",
        "Direct Communication",
        "Successful Delivery of Project"
      ]
    },
    {
      id: "time-material",
      title: "Time and Material Model",
      desc: "Time and material engagement model enables clients to pay for completed work rather than committing to a fixed project cost. This approach offers the flexibility to adapt to evolving business requirements.",
      benefits: [
        "Faster project start",
        "Dynamic work scope",
        "Fair price",
        "Flexibility",
        "Pay as you go"
      ],
      cta: "Let's Talk",
      hexagons: [
        "Requirements Gathering",
        "Analysis & Planning",
        "Our T&M Proposal",
        "Approval of Work & Commencement",
        "Work Request",
        "Implementation & Delivery"
      ]
    }
  ];

  const nextModel = () => {
    setCurrentModel((prev) => (prev + 1) % models.length);
  };

  const prevModel = () => {
    setCurrentModel((prev) => (prev === 0 ? models.length - 1 : prev - 1));
  };

  const model = models[currentModel];

  return (
    <section className="models-section">
      <div className="models-container">
        <div key={model.id} className="model-slide">
          <div className="model-content">
            <h2 className="model-title">
              <span style={{ color: '#54b248' }}>{model.title.split(' ')[0]}</span> <span style={{ color: 'white' }}>{model.title.split(' ').slice(1).join(' ')}</span>
            </h2>
            <p className="model-desc">{model.desc}</p>

            <h3 className="benefits-title" style={{ color: 'white' }}>
              <span style={{ color: '#54b248' }}>Benefits of Our</span> {model.title}
            </h3>
            <ul className="benefits-list">
              {model.benefits.map((benefit, i) => (
                <li key={i}><h4>{benefit}</h4></li>
              ))}
            </ul>

            {/* Hidden for visual users but present for SEO/Accessibility */}
            <div className="sr-only-seo">
              <h3>Our {model.title} Process</h3>
              <ul>
                {(model.nodes || model.steps || model.hexagons || []).map((step, i) => (
                  <li key={i}><h4>{typeof step === 'string' ? step : step.label}</h4></li>
                ))}
              </ul>
            </div>

            <button className="model-cta">{model.cta}</button>
          </div>

          <div className="model-infographic">
            <div className="infographic-main-wrapper">
              {model.id === "fixed-price" && (
                <img src={fixedPriceImg.src || fixedPriceImg} alt="Fixed Price Model Process" className="fixed-price-infographic-img" />
              )}
              {model.id === "dedicated" && (
                <img src={dedicatedImg.src || dedicatedImg} alt="Dedicated Hiring Model Process" className="dedicated-infographic-img" />
              )}
              {model.id === "time-material" && (
                <img src={tmImg.src || tmImg} alt="Time and Material Model Process" className="tm-infographic-img" />
              )}
            </div>
          </div>
        </div>

        <div className="slider-controls">
          <button className="control-btn" onClick={prevModel}><ChevronLeft size={20} /></button>
          <button className="control-btn" onClick={nextModel}><ChevronRight size={20} /></button>
        </div>
      </div>
    </section>
  );
};

export default ModelsSection;
